import { render, staticRenderFns } from "./FilterAppBrowseField.vue?vue&type=template&id=2a0a0e0a"
import script from "./FilterAppBrowseField.vue?vue&type=script&lang=ts"
export * from "./FilterAppBrowseField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/search/filter.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Ffilter%2Fform%2FFilterAppBrowseField.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports